export enum IconState {
    Default = 'default',
    Rotated = 'rotated',
}
